(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  function bindReviews(root = document) {
    document.dispatchEvent(new Event('theme-stack:reviews-updated'));
    root.querySelectorAll('[data-review-widget]').forEach((section) => {
      if (section.dataset.reviewReady) return;
      section.dataset.reviewReady = 'true';
      const track = section.querySelector('[data-review-track]');
      const controls = section.querySelector('[data-review-controls]');
      const previous = section.querySelector('[data-review-previous]');
      const next = section.querySelector('[data-review-next]');
      const pause = section.querySelector('[data-review-pause]');
      if (!track || !controls || !previous || !next) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cards = Array.from(track.querySelectorAll('[data-review-card]'));
      let timer;
      let userPaused = false;
      let hovered = false;
      let focused = false;
      const reduced = () => document.body.dataset.motion === 'false' || motion.matches;
      const overflow = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const autoEnabled = () => section.dataset.reviewAutoplay === 'true' && cards.length > 1 && !reduced();
      const schedule = () => {
        window.clearTimeout(timer);
        timer = undefined;
        if (!autoEnabled() || overflow() < 2 || userPaused || hovered || focused || document.hidden) return;
        timer = window.setTimeout(() => { step(1, false); schedule(); }, 8000);
      };
      const update = () => {
        const maximum = overflow();
        controls.hidden = maximum < 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
        if (pause) {
          pause.hidden = !autoEnabled() || maximum < 2;
          pause.textContent = userPaused ? 'Resume' : 'Pause';
          pause.setAttribute('aria-pressed', String(userPaused));
          pause.setAttribute('aria-label', userPaused ? 'Resume automatic review movement' : 'Pause automatic review movement');
        }
      };
      const refresh = () => { update(); schedule(); };
      const stopForInteraction = () => { userPaused = true; refresh(); };
      const step = (direction, manual = true) => {
        const first = cards[0];
        if (!first) return;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const cardWidth = first.getBoundingClientRect().width + gap;
        if (cardWidth <= 0) return;
        const current = Math.round(track.scrollLeft / cardWidth);
        const nextIndex = Math.max(0, Math.min(cards.length - 1, current + direction));
        const wrap = !manual && track.scrollLeft >= overflow() - 2;
        const target = wrap ? 0 : Math.min(overflow(), nextIndex * cardWidth);
        if (manual) stopForInteraction();
        track.scrollTo({ left: target, behavior: reduced() ? 'auto' : 'smooth' });
        const status = section.querySelector('[data-review-status]');
        if (manual && status) status.textContent = `Review ${nextIndex + 1} of ${cards.length}.`;
      };
      previous.addEventListener('click', () => step(-1, true));
      next.addEventListener('click', () => step(1, true));
      pause?.addEventListener('click', () => { userPaused = !userPaused; refresh(); });
      section.addEventListener('mouseenter', () => { hovered = true; refresh(); });
      section.addEventListener('mouseleave', () => { hovered = false; refresh(); });
      section.addEventListener('focusin', () => { focused = true; refresh(); });
      section.addEventListener('focusout', (event) => { focused = section.contains(event.relatedTarget); refresh(); });
      track.addEventListener('pointerdown', stopForInteraction, { passive: true });
      track.addEventListener('keydown', (event) => { if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) stopForInteraction(); });
      track.addEventListener('scroll', update, { passive: true });
      const visibilityChanged = () => refresh();
      document.addEventListener('visibilitychange', visibilityChanged);
      motion.addEventListener?.('change', refresh);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(refresh);
        observer.observe(track);
        section.reviewResizeObserver = observer;
      } else {
        window.addEventListener('resize', refresh);
        section.reviewResizeHandler = refresh;
      }
      section.reviewCleanup = () => {
        window.clearTimeout(timer);
        document.removeEventListener('visibilitychange', visibilityChanged);
        motion.removeEventListener?.('change', refresh);
      };
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindReviews());
  else bindReviews();
  document.addEventListener('shopify:section:load', (event) => bindReviews(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-review-widget]').forEach((section) => {
      section.reviewResizeObserver?.disconnect();
      if (section.reviewResizeHandler) window.removeEventListener('resize', section.reviewResizeHandler);
      section.reviewCleanup?.();
    });
    window.setTimeout(() => document.dispatchEvent(new Event('theme-stack:reviews-updated')), 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
